import { Instance } from 'mobx-state-tree';
import { RouteSolutionDownloadDtoModelBase } from './RouteSolutionDownloadDtoModel.base';

/* The TypeScript type of an instance of RouteSolutionDownloadDtoModel */
export interface RouteSolutionDownloadDtoModelType extends Instance<typeof RouteSolutionDownloadDtoModel.Type> {}

/* A graphql query fragment builders for RouteSolutionDownloadDtoModel */
export { selectFromRouteSolutionDownloadDto, routeSolutionDownloadDtoModelPrimitives, RouteSolutionDownloadDtoModelSelector } from './RouteSolutionDownloadDtoModel.base';

/**
 * RouteSolutionDownloadDtoModel
 */
export const RouteSolutionDownloadDtoModel = RouteSolutionDownloadDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
